import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/images/pirelli_diablo_super_sport_2_detail.jpg")